<div class="outside-box">
  @if(!production) {
  <div class="dev-banner">
    <p><strong>Development Mode</strong></p>
  </div>
  }
  <div class="inside-box">
    <mat-card class="login-card">
      <div class="logo-container">
        <img src="/logo.png" alt="Company Logo" class="login-logo" />
      </div>

      <mat-card-header>
        <mat-card-title>New Account Setup</mat-card-title>
        <mat-card-subtitle>
          Please enter your email and phone number to set up your new account.
        </mat-card-subtitle>
      </mat-card-header>

      <mat-card-content>
        <form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="login-form">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Email</mat-label>
            <input matInput type="email" formControlName="email" required autocomplete="off">

          </mat-form-field>

          <div class="phone-input-group">
            <mat-form-field appearance="outline" class="country-code-field">
              <mat-label>Code</mat-label>
              <span matPrefix style="padding-left: 5px;"> +&nbsp;</span>
              <mat-select formControlName="countryCode">
                <mat-select-trigger>
                  {{ selectedCountryDialCode }}
                </mat-select-trigger>
                @for (country of countries; track country.code) {
                <mat-option [value]="country.code">
                  {{ country.name }} (+{{ country.dialCode }})
                </mat-option>
                }
              </mat-select>
            </mat-form-field>

            <mat-form-field appearance="outline" class="phone-number-field">
              <mat-label>Phone Number</mat-label>
              <input matInput type="tel" formControlName="phoneNumber" required autocomplete="off">
            </mat-form-field>
          </div>

          <div class="form-actions">
            <button mat-flat-button color="primary" type="submit" class="submit-button"
              [disabled]="loginForm.invalid || accountService.isLoading">
              Set Up Account
            </button>
          </div>
        </form>
      </mat-card-content>
      <mat-card-actions class="additional-actions">
        <a routerLink="/login" class="action-link">Go back to Login</a>
        <a routerLink="/forgot-password" class="action-link">Forgot Password?</a>
      </mat-card-actions>
    </mat-card>
  </div>
</div>